import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class CommonFunction {
  FileExtension: any;
  fileExtension: any;
  secretKey = 'Secret message';
  constructor(private router: Router) {}
  validateURL(module, permission): boolean {
    if (environment.PSS == true) {
        return true
    } else {
        var returningValue = false;
        // var dashboardUrl = environment.govEvaUIBaseUrl + environment.GovevaDashboardUrl;

        const self = this;
        var hasPermission = [];
        var flag: boolean;
        flag = false;
        const resourcesValue = JSON.parse(localStorage.getItem('resources'));
        _.forEach(resourcesValue, function (data) {
            if (data.Menu == module) {
                flag = true;

                if (data.ChildResources.length == 2) {
                    returningValue = true
                    // return true;
                }
                else if (data.ChildResources.length == 1) {
                    if (permission == 'add' && environment.PSS == false) {

                        this.router.navigate(['/authAlert']);
                    }
                    else {
                        returningValue = false
                        // return false;
                    }
                }
            }

        });
        if (flag == false && environment.PSS == false) {
            this.router.navigate(['/authAlert']);
            // window.location.href = dashboardUrl;
        }
        return returningValue;
    }

}

sanitizedFileName(filename){
  return filename.replace(/[() ]/g, "_")
}
  sortByKey(array, key) {
    return array.sort(function (a, b) {
      var x = a[key].toLowerCase();
      var y = b[key].toLowerCase();
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }

  sortByasc(array, key) {
    return array.sort(function (a, b) {
        var x = a[key]; var y = b[key];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}
  checkFileExtensionForMeetingAgendaDocuments($event) {
    var count=0;
    var self=this;
    console.log('file changed', $event.target.files[0])
    var allowedExtensions = ["docx","pdf"];
    var filename = $event.target.files[0].name;
    //console.log("filename.split('.')",filename.split('.'));
   // console.log("filename.split('.')[1].toLowerCase();",filename.split('.')[1].toLowerCase());
   var checkFilesExtension=filename.toString().split('.').pop();
   console.log(" checkFilesExtension : ====>  ", checkFilesExtension )
    this.fileExtension = filename.split('.');
    console.log(" this.fileExtension ", this.fileExtension )
    this.fileExtension.forEach(function(value, key) {
        console.log(key + ': ' + value);
        if(self.isInArray(self.allExtensions(), value))
        {
            count++; 
        }
      });

      console.log('count : ',count);
   
    if (count==1 && self.isInArray(allowedExtensions, checkFilesExtension)) {       
        return true;
    }
    else {

        return false;

    }
}
 //NEW Code ->Issuse Unrestricted File Upload
 checkFileExtensionForAgendaDocuments($event) {
  var count = 0;
  var self = this;
  console.log('file changed', $event.target.files[0])
  var allowedExtensions = ["docx"];
  var filename = $event.target.files[0].name;
  //console.log("filename.split('.')",filename.split('.'));
  // console.log("filename.split('.')[1].toLowerCase();",filename.split('.')[1].toLowerCase());
  var checkFilesExtension = filename.toString().split('.').pop();
  console.log(" checkFilesExtension : ====>  ", checkFilesExtension)
  this.fileExtension = filename.split('.');
  console.log(" this.fileExtension ", this.fileExtension)
  this.fileExtension.forEach(function (value, key) {
      console.log(key + ': ' + value);
      if (self.isInArray(self.allExtensions(), value)) {
          count++;
      }
  });
  console.log('count : ', count);

  if (count == 1 && self.isInArray(allowedExtensions, checkFilesExtension)) {
      return true;
  }
  else {

      return false;

  }
}
  setDate(date: any): string | null {
    if (!date && date !== 0) {
      return null;
    }

    const toIsoString = (inputDate: Date) => {
      if (!(inputDate instanceof Date) || isNaN(inputDate.getTime())) {
        return null;
      }
      return inputDate.toISOString();
    };

    // Moment.js objects
    if (date && date._isAMomentObject && typeof date.toDate === 'function') {
      return toIsoString(date.toDate());
    }

    // Native Date instance
    if (date instanceof Date) {
      return toIsoString(date);
    }

    // Angular datepicker model { year, month, day } (+ optional hour/minute/second)
    if (typeof date === 'object' && date.year !== undefined && date.month !== undefined && date.day !== undefined) {
      const year = Number(date.year);
      const month = Number(date.month);
      const day = Number(date.day);
      const hour = date.hour !== undefined ? Number(date.hour) : 0;
      const minute = date.minute !== undefined ? Number(date.minute) : 0;
      const second = date.second !== undefined ? Number(date.second) : 0;
      const millisecond = date.millisecond !== undefined ? Number(date.millisecond) : 0;

      if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
        const iso = new Date(Date.UTC(year, month - 1, day, hour, minute, second, millisecond));
        return toIsoString(iso);
      }
    }

    // Numeric timestamp
    if (typeof date === 'number') {
      return toIsoString(new Date(date));
    }

    // String inputs
    if (typeof date === 'string') {
      if (!date.trim()) {
        return null;
      }

      const parsed = new Date(date);
      if (!isNaN(parsed.getTime())) {
        return toIsoString(parsed);
      }

      // Attempt to parse common dd-mm-yyyy / mm-dd-yyyy formats
      const normalized = date.replace(/\./g, '-').replace(/\//g, '-');
      const parts = normalized.split('-');
      if (parts.length === 3) {
        const [part1, part2, part3] = parts.map(p => Number(p));
        let year: number;
        let month: number;
        let day: number;

        if (String(parts[0]).length === 4) {
          year = part1;
          month = part2;
          day = part3;
        } else if (String(parts[2]).length === 4) {
          year = part3;
          month = part1;
          day = part2;
        }

        if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
          const iso = new Date(Date.UTC(year, month - 1, day));
          return toIsoString(iso);
        }
      }
    }

    return null;
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  //format number with commas
  formatToCommaSeperatedNumber(value) {
    if (value != null) {
      value = value.toString();
      if (value == null || value == '' || value == undefined) {
        return '';
      }

      var valArray = value.split('.') || [];

      for (var i = 0; i < valArray.length; ++i) {
        valArray[i] = valArray[i].replace(/[^\d.-]/g, '');
      }

      var newVal;

      if (valArray.length === 0) {
        newVal = '';
      } else {
        let matches = valArray[0].match(/[0-9]{3}/gim);

        if (matches !== null && valArray[0].length > 3) {
          let commaGroups = Array.from(
            Array.from(valArray[0])
              .reverse()
              .join('')
              .match(/[0-9]{3}/gim)
              .join()
          )
            .reverse()
            .join('');
          let replacement = valArray[0].replace(
            commaGroups.replace(/[^\d.-]/g, ''),
            ''
          );

          if (parseInt(valArray[0]) > 0) {
            newVal =
              (replacement.length > 0 ? replacement + ',' : '') + commaGroups;
          } else {
            newVal = (replacement.length > 0 ? replacement : '') + commaGroups;
          }
        } else {
          newVal = valArray[0];
        }

        if (valArray.length > 1) {
          newVal += '.' + valArray[1].substring(0, 2);
        }
      }

      return newVal;
    }
  }

  removeDataTableSaveStateKey(tableID) {
    var dataTablekey = 'DataTables_' + tableID + '_/';
    sessionStorage.removeItem(dataTablekey);
  }

  allExtensions() {
    return [
      'csv',
      'xlsx',
      'xls',
      'jpg',
      'jpeg',
      'png',
      'doc',
      'docx',
      'txt',
      'pdf',
      'ppt',
      'pptx',
      'mp4',
      'apk',
      'bat',
      'bin',
      'cgi',
      'com',
      'exe',
      'jar',
      'py',
      'wsf',
      'aif',
      'cda',
      'iff',
      'mid',
      'midi',
      'mp3',
      'mpa',
      'wav',
      'wma',
      'wpl',
      'avi',
      'flv',
      'h264',
      'm4v',
      'mkv',
      'mov',
      'mpg',
      'mpeg',
      'rm',
      'swf',
      'vob',
      'wmv',
      '3g2',
      '3gp',
      'odt',
      'msg',
      'rtf',
      'tex',
      'wks',
      'wps',
      'wpd',
      'ods',
      'xlr',
      'key',
      'odp',
      'pps',
      'accdb',
      'dat',
      'db',
      'dbf',
      'log',
      'mdb',
      'pdb',
      'sav',
      'sql',
      'tar',
      'bak',
      'cab',
      'cfg',
      'cpl',
      'cur',
      'dll',
      'dmp',
      'drv',
      'icns',
      'ico',
      'ini',
      'lnk',
      'msi',
      'sys',
      'tmp',
      'asp',
      'aspx',
      'cer',
      'cfm',
      'cgi',
      'pl',
      'css',
      'htm',
      'html',
      'js',
      'jsp',
      'part',
      'php',
      'rss',
      'xhtml',
      'ai',
      'bmp',
      'gif',
      'ico',
      'max',
      'obj',
      'ps',
      'psd',
      'svg',
      'tif',
      'tiff',
      '3ds',
      '3dm',
    ];
  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  //old code
  // checkFileExtension($event) {
  //     console.log('file changed', $event.target.files[0])
  //     var allowedExtensions = ["csv", "xlsx", "xls", "csv", "jpg", "jpeg", "png", "doc", "docx", "txt", "pdf", "ppt", "mp4"];
  //     var filename = $event.target.files[0].name;
  //     this.FileExtension = filename.toString().split('.').pop();
  //     console.log("filename", filename);
  //     console.log("FileExtension", this.FileExtension);

  //     if (this.isInArray(allowedExtensions, this.FileExtension)) {
  //         return true;
  //     } else {

  //         return false;

    //old code
    // checkFileExtension($event) {
    //     console.log('file changed', $event.target.files[0])
    //     var allowedExtensions = ["csv", "xlsx", "xls", "csv", "jpg", "jpeg", "png", "doc", "docx", "txt", "pdf", "ppt", "mp4"];
    //     var filename = $event.target.files[0].name;
    //     this.FileExtension = filename.toString().split('.').pop();
    //     console.log("filename", filename);
    //     console.log("FileExtension", this.FileExtension);

    //     if (this.isInArray(allowedExtensions, this.FileExtension)) {
    //         return true;
    //     } else {
            
    //         return false;
          
    //     }
    // }

    //new code for unrestricted file upload

    checkFileExtension($event) {
        var count=0;
        var self=this;
        console.log('file changed', $event.target.files[0])
        var allowedExtensions = ["csv", "xlsx", "xls", "jpg", "jpeg", "png", "doc", "docx", "txt", "pdf", "ppt","pptx", "mp4"];
        var filename = $event.target.files[0].name;
        //console.log("filename.split('.')",filename.split('.'));
       // console.log("filename.split('.')[1].toLowerCase();",filename.split('.')[1].toLowerCase());
       var checkFilesExtension=filename.toString().split('.').pop();
       console.log(" checkFilesExtension : ====>  ", checkFilesExtension )
         this.FileExtension = filename.split('.');
        console.log("  this.FileExtension ",  this.FileExtension )
         this.FileExtension.forEach(function(value, key) {
            console.log(key + ': ' + value);
            if(self.isInArray(self.allExtensions(), value))
            {
                count++; 
            }
          });

          console.log('count : ',count);
       
        if (count==1 && self.isInArray(allowedExtensions, checkFilesExtension)) {
            return true;
        }
        else {
            
            return false;
          
        }
     
      
    }
    checkIfFileNameIsCorrect($event, actualEvent){
      var ele = actualEvent.srcElement;
      var filename = $event.target.files[0].name;
      if(filename.includes(",") || filename.includes("]") || filename.includes("[")){
          //need to reset the event values
          const dT = new  DataTransfer();
          actualEvent.target.files = dT.files;
          return "Filename cannot contain these characters: Comma:','  SquareOpenBracket'[' SquareCloseBracket:']' ";
      }else{
           return "Valid";
      }
  }

  validateModulePermitions(module, Url): boolean {
    var returningValue = false;
    if (environment.Service.PSS == false) {
        const resourcesValue = JSON.parse(localStorage.getItem('resources'));
        _.forEach(resourcesValue, function (data) {
            if (data.Menu == module) {
                for (var i = 0; i < _.size(data.ChildResources); i++) {
                    var childrenData = data.ChildResources[i];
                    if (Url == childrenData.Url) {
                        returningValue = true;
                    }
                }
            }
        });
        return returningValue;

    } else {
        // const resourcesValue = JSON.parse(localStorage.getItem('resources'));
        // _.forEach(resourcesValue, function (data) {
        //     if (data.Menu == module) {
        //         for (var i = 0; i < _.size(data.ChildResources); i++) {
        //             var childrenData = data.ChildResources[i];
        //             if (Url == childrenData.Url) {
        //                 returningValue = true;
        //             }
        //         }
        //     }
        // });
        // return returningValue;
        return true;
    }
}
 
    encrypt(value : string) : string{
        return CryptoJS.AES.encrypt(value, this.secretKey.trim()).toString();
    }
    
    decrypt(textToDecrypt : string, secret = this.secretKey.trim()){
      return CryptoJS.AES.decrypt(textToDecrypt, secret).toString(CryptoJS.enc.Utf8);
    }
    
    returnFilenameAfterfirstHypen(filename){
      if(filename){
          if(filename.includes("-")){
              var hypenind = filename.indexOf("-");
              return filename.slice(hypenind+1,filename.length);
          }
      }
  }
  checkFileExtensionForNCD($event) {
    var count = 0;
    var self = this;
    console.log('file changed', $event.target.files[0])
    var allowedExtensions = ["csv", "xlsx", "xls", "doc", "docx", "txt", "pdf", "ppt", "zip"];
    var filename = $event.target.files[0].name;
    //console.log("filename.split('.')",filename.split('.'));
    // console.log("filename.split('.')[1].toLowerCase();",filename.split('.')[1].toLowerCase());
    var checkFilesExtension = filename.toString().split('.').pop();
    console.log(" checkFilesExtension : ====>  ", checkFilesExtension)
    this.fileExtension = filename.split('.');
    console.log(" this.fileExtension ", this.fileExtension)
    this.fileExtension.forEach(function (value, key) {
        console.log(key + ': ' + value);
        if (self.isInArray(self.allExtensions(), value)) {
            count++;
        }
    });

    console.log('count : ', count);

    if (count == 1 && self.isInArray(allowedExtensions, checkFilesExtension)) {
        return true;
    }
    else {

        return false;

    }


}
  }
